<mat-dialog-title class="dialog-title">
    @if (data.type == 1) {
      <mat-icon style="color: #ffb516; font-size: 48px; width:48px; height:48px; margin-right: 12px;">warning</mat-icon>
    }
    @if (data.type == 2) {
      <mat-icon style="color: #db0000; font-size: 48px; width:48px; height:48px; margin-right: 12px;">error</mat-icon>
    }
    @if (data.type == 3) {
      <mat-icon style="color: #004487; font-size: 48px; width:48px; height:48px; margin-right: 12px;">help</mat-icon>
    }
    @if (data.type == 4) {
      <mat-icon style="color: #004487; font-size: 48px; width:48px; height:48px; margin-right: 12px;">info</mat-icon>
    }
    {{data.title | translate}}
</mat-dialog-title>

<mat-divider></mat-divider>
<div mat-dialog-content>
  <p>{{data.content | translate}}</p>
</div>

<div mat-dialog-actions>
  <button mat-flat-button color="primary" class="button-dialog"
  [mat-dialog-close]="true">{{data.yes | translate}}</button>
  @if (data.no != '') {
    <button mat-flat-button color="primary" class="button-dialog"
    [mat-dialog-close]="false">{{data.no | translate}}</button>
  }
</div>
